import React from "react"
import { FormControl as MuiFormControl } from "@material-ui/core"

export const FormControl = ({ className, variant = "outlined", children, ...props }) => (
	<MuiFormControl className={className} variant={variant} {...props}>
		{children}
	</MuiFormControl>
)
